import { render, staticRenderFns } from "./ipv6Component.vue?vue&type=template&id=41d67963&scoped=true&"
import script from "./ipv6Component.vue?vue&type=script&lang=js&"
export * from "./ipv6Component.vue?vue&type=script&lang=js&"
import style0 from "./ipv6Component.vue?vue&type=style&index=0&id=41d67963&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d67963",
  null
  
)

export default component.exports